import React from 'react';
import { Props } from '@components/divider/divider.type';
import { mergeTwClasses } from '@utils/merge-tw-classes/merge-tw-classes';

const RULE = 'h-[1px] w-full bg-neutral-8 dark:bg-neutral-50';
const RULE_ON_INVERSE = 'h-[1px] w-full bg-neutral-80 dark:bg-neutral-8';

// Destructured out so React does not warn about an unknown attribute — it never reaches the DOM
// either way, so there is nothing testable here beyond the rule's own classes.
export const Divider = ({ className, inverse = false, ...props }: Props) => (
  <div
    className={mergeTwClasses(
      'mx-auto my-6 flex w-full items-center justify-between gap-3 text-sm text-neutral-50 dark:text-neutral-0',
      className
    )}
    {...props}>
    <div className={inverse ? RULE_ON_INVERSE : RULE} />
  </div>
);
